import {get, post, postJson, imagePost, deleteApi} from '../axios'

const RESOURCE_BASE_PATH = 'dong-dong'

// 获取群组列表
export const getGroupList = p => get(`${RESOURCE_BASE_PATH}/group/list`, p);

// 查询群发记录
export const getGroupRecord = p => postJson(`${RESOURCE_BASE_PATH}/group-chat/marking/record/page`, p);

// 同步商家群数据
export const syncGroup = p => post(`${RESOURCE_BASE_PATH}/group/groupInfoSync`, p);

// 上传图片
export const uploadpic = p => imagePost(`common/uploadPic`, p);

// 保存草稿
export const saveDraft = p => postJson(`${RESOURCE_BASE_PATH}/group-chat/draft/save`, p);

// 获取草稿
export const getDraft = p => get(`${RESOURCE_BASE_PATH}/group-chat/draft/get`, p)

// 提交发送
export const submitGroup = p => postJson(`${RESOURCE_BASE_PATH}/group-chat/marking/submit`, p)

// 发送日志
export const getCycleDetail = p => get(`${RESOURCE_BASE_PATH}/group-chat/cycle-detail/page`, p)

// 停止循环
export const getCycleStop = p => get(`${RESOURCE_BASE_PATH}/group-chat/status`, p)

// 一键清空
export const getClear = p => get(`${RESOURCE_BASE_PATH}/group-chat/draft/clear`, p)

// =================================================================================================> 专属客服接口
// 发送专享消息（邀请专享用户）分页接口
export const getExclusiveWaiterList = p => get(`${RESOURCE_BASE_PATH}/exclusiveWaiter/page`, p);

// 发送专享信息（邀请专享用户）活动详情接口
export const exclusiveWaiterDetail = p => get(`${RESOURCE_BASE_PATH}/exclusiveWaiter/detail/${p}`);

// 查询是否开通专属客服
export const isOpen = p => get(`${RESOURCE_BASE_PATH}/exclusiveWaiter/isOpen`, p);

// 循环发送发送明细接口
export const recycleSendRecordPage = p => get(`${RESOURCE_BASE_PATH}/exclusiveWaiter/recycleSendRecordPage`, p);

// 删除专属客服活动
export const deleteActivity = p => deleteApi(`${RESOURCE_BASE_PATH}/exclusiveWaiter/deleteActivity/${p}`);

// 终止发送专属客服
export const stopExclusiveWaiterPlan = p => post(`${RESOURCE_BASE_PATH}/exclusiveWaiter/stopExclusiveWaiterPlan/${p}`);

// 获取发送客服列表
export const getWaiterList = p => get(`${RESOURCE_BASE_PATH}/exclusiveWaiter/waiterList`, p);

// 邀请语查询接口
export const getInviteTxt = p => get(`${RESOURCE_BASE_PATH}/exclusiveWaiter/inviteTxt`, p);

// 专属客服提交发送
export const exclusiveWaiterSend = p => postJson(`${RESOURCE_BASE_PATH}/exclusiveWaiter/send`, p)

// 专属客服修改
export const exclusiveWaiterUpdate = p => postJson(`${RESOURCE_BASE_PATH}/exclusiveWaiter/updateActivity`, p)

// 获取咚咚效果分析执行周期信息
export const activityCycleList = p => get(`${RESOURCE_BASE_PATH}/exclusiveWaiter/activityCycleList/${p}`);

// 生成咚咚专属标签人群
export const insertExculusiveCrowd = p => post(`/memberCrowd/insertExculusiveCrowd`);